import { QuantityStepper } from "./QuantityStepper.jsx";
import "./army-picker.css";
const names = ["Стражи", "Штурмовики", "Алхимики"];
export function ArmyPicker({value, onChange, player, disabled}) {
  return <div className="kh-army-picker">{names.map((name,i)=><div className="kh-army-choice" key={name}>
    <header><img src={`/assets/king-hill/troop-${i}.webp`} alt=""/><div><b>{name}</b><small>Ур. {player?.levels?.[i] || 1} · доступно {player?.army?.[i] || 0}</small></div></header>
    <QuantityStepper value={value[i]} max={player?.army?.[i] || 0} disabled={disabled} label={`Количество: ${name}`} onChange={n=>onChange(value.map((v,j)=>i===j?n:v))}/>
  </div>)}</div>;
}
